module.exports = __webpack_public_path__ + "img/locks.59fea865.png";